export const defaultResponseStatus = 200;

export const unaryMatchers = ["ShouldBeEmpty", "ShouldNotBeEmpty"];

export const positiveMatchers = [
  "ShouldEqual",
  "ShouldMatch",
  "ShouldContainSubstring",
  "ShouldBeEmpty",
  "ShouldStartWith",
  "ShouldEndWith",
];

export const negativeMatchers = [
  "ShouldNotEqual",
  "ShouldNotMatch",
  "ShouldNotBeEmpty",
  "ShouldNotContainSubstring",
  "ShouldNotStartWith",
  "ShouldNotEndWith",
];
